module.exports = __webpack_public_path__ + "img/r-logo-white.90a85d1b.png";